<template>
    <div class="pipeline-panel">
        <div class="pipeline-title font-color">市政管线</div>
        <el-checkbox class="font-color allchecked" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部选择</el-checkbox>
        <el-checkbox-group v-model="checkedPipelines" @change="handleCheckedPipelinesChange">
            <div class="checkbox-list" v-for="(item,index) in infoData" :key="index">
                <el-checkbox :key="item.code" :label="item.code"><img v-bind:style="{opacity: checkedPipelines.includes(item.code)?1:0.6}" :src="require(`../../assets/images/digital/pipeline/${item.code}.png`)"/></el-checkbox>
                <span class="label" v-bind:style="{color: item.color, opacity: checkedPipelines.includes(item.code)?1:0.6}">{{item.name}}</span>
            </div>
        </el-checkbox-group>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "Pipeline",
    props: {
        lotList: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data() {
        return {
            infoData: [],
            checkAll: false,
            checkedPipelines: [],
            isIndeterminate: false
        }
    },
    created() {
        this.getDataAxios()
    },
    mounted() {
        //修改地块颜色
        let color = {}
        for(let lot of this.lotList) {
            color[lot.lotNumber] = '#071129'
        }
        let pipelineSheme = {
            field: 'BLK',
            colorInfo: color
        }
        this.setGisSchemeAsync(pipelineSheme)
    },
    watch: {
        checkedPipelines(val) {
            let colors = {}
            for(let item of this.infoData) {
                if(val.includes(item.code)) {
                    colors[item.code] = item.color
                } else {
                    colors[item.code] = ''
                }
            }
            this.setPipelineColorsAsync(colors)
        }
    },
    methods: {
        ...mapActions('gisData', ['setGisSchemeAsync', 'setPipelineColorsAsync']),
        //获取管线信息
        getDataAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/pipeline`
            this.$common.getTokenRequest()
            .get(url)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.infoData = data.data;
                    let allchecked = data.data.map( item => item.code)
                    this.handleCheckAllChange(allchecked)
                    this.checkAll = true
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/pipeline')
            })
        },
        handleCheckAllChange(val) {
            let checked = this.infoData.map(item => {
                return item.code;
            });
            this.checkedPipelines = val ? checked : [];
            this.isIndeterminate = false;
        },
        handleCheckedPipelinesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.infoData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.infoData.length;
        }
    }
}
</script>

<style lang="scss" scoped>
.pipeline-panel {
    width: 100%;
    .pipeline-title {
        font-size: 16px;
        font-family: SourceHanSansCN-Heavy;
        font-weight: 800;
        margin-bottom: 16px;
    }
    .allchecked {
        margin-bottom: 6px;
    }
    .checkbox-list {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        .label {
            font-size: 14px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
        }
        img {
            height: 9px;
        }
    }
    /deep/ .el-checkbox__label {
        font-size: 14px;
        font-weight: 600;
        color: #2899FF;
    }
    /deep/ .el-checkbox__inner {
        border: 3px solid #2899FF;
        background-color: transparent;
        width: 20px;
        height: 20px;
        border-radius: 4px;
    }
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #2899FF;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #2899FF;
        border-color: #2899FF;
        color: #fff;
    }
    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner, /deep/ .el-checkbox__input .el-checkbox__inner:hover, .el-checkbox__input:hover {
        border-color: #2899FF;
    }
    // 对号
    /deep/ .el-checkbox__input .el-checkbox__inner::after {
        border: 2.8px solid #fff;
        box-sizing: content-box;
        content: " ";
        border-left: 0;
        border-top: 0;
        height: 10px;
        left: 3px;
        position: absolute;
        top: -2px;
        width: 5px;
    }
    /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
        content: " ";
        transform: scale(0.8);
        top: 6px;
    }
}
</style>
<style lang="scss">


</style>